import { render, staticRenderFns } from "./AvatarManager.vue?vue&type=template&id=74585d8c&"
import script from "./AvatarManager.vue?vue&type=script&lang=js&"
export * from "./AvatarManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports